import { createContext, useState } from "react";

export const ChemicalFormulaContext = createContext("");

export const FormulaProvider = (props) => {
  const { children } = props;
  const [elements, setElements] = useState(new Map());

  return (
    <ChemicalFormulaContext.Provider value={{ elements, setElements }}>{children}</ChemicalFormulaContext.Provider>
  );
};
